import { Controller } from "@hotwired/stimulus"
import loadMembers from "../loadMembers"

const waiting = "<div class='spinner'><div class='double-bounce1'></div><div class='double-bounce2'></div></div>"
const tabletWidth = 1024

export default class extends Controller {
  static targets = [ "input", "list", "contactTab"]

  connect() {
    this.searchTimeout = null
    this.setupIntersectionObserver()
  }

  disconnect() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect()
    }
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }
  }

  setupIntersectionObserver() {
    this.intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio > 0) {
          // Element is visible, trigger search
          this.searchMembers()
          // Optionally disconnect after first visibility if you only want to load once
          this.intersectionObserver.disconnect()
        }
      })
    }, {
      threshold: 0.1, // Trigger when 10% of the element is visible
      rootMargin: '50px' // Start loading 50px before the element comes into view
    })

    this.intersectionObserver.observe(this.element)
  }

  searchMembers(){
    if (this.hasListTarget) {
      const $memberList = $(this.listTarget)
      const scope = this.data.get('scope')
      const appendMember = this.appendMember
      this.pageNumber = 1
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout( () =>  loadMembers(this.inputTarget, this.pageNumber, scope).then(data => {
        $.each(data, function( index, value ) {
          appendMember($memberList, value)
        });
      }), 350)
    }
  }

  desktop(){
    return window.innerWidth >= tabletWidth
  }

  appendMember($memberList, value){
    const $newEl = $(value.html_tag)
    const id = $newEl.attr('id')
    if (!document.getElementById(id)) {
      $memberList.append(value.html_tag)      
    }
  }

  setListHeight(){
    const height = this.listHeight
    this.element.querySelectorAll('.list-box').forEach(e => e.style.height = `${height}px`)
  }

  get listHeight(){
    // header - footer - search - tabs - searchPaddingTop - 16
    const offsetHeight = this.element.offsetHeight
    return offsetHeight - 80 - 70 - 48 - 56 - 24 - 16
  }

  get pageNumber(){
    return parseInt(this.data.get('pageNumber') || '1')
  }
  set pageNumber(value){
    this.data.set('pageNumber', value)
  }

  get loadingMore(){
    return this.data.get('loadingMore')
  }
  set loadingMore(value){
    this.data.set('loadingMore', value)
  }

  get isContactsActive() {
    return this.contactTabTarget.classList.contains('active')
  }

  loadMore(){
    if (this.loadingMore == true) {
      return
    }
    const $memberList = $(this.listTarget)
    const appendMember = this.appendMember
    const scope = this.data.get('scope')
    this.loadingMore = true
    this.pageNumber++
    loadMembers(this.inputTarget, this.pageNumber, scope).then(data => {
      this.loadingMore = false
      $.each(data, function( index, value ) {
        appendMember($memberList, value)
      });
    })
  }
  
  infiniteScroll(event) {
    if (this.hasContactTabTarget && !this.isContactsActive) {
      return
    }
    const element = event.currentTarget
    if (element.scrollHeight - Math.ceil(element.scrollTop) <= element.clientHeight) {
      this.loadMore()
    }
  }
}
